<template>
  <div  class="login-div w" :class="{'is-height':screenHeight,'is-width':clientWidth,}">
    <div class="login-centen-div">
    <div  class="login-img">
        <span class="login-img-fontBig">企业服务商城</span>
        <span class="login-img-fontMedll">人力资源全产业链商品</span>
        <span class="login-img-fontSmall">一站式服务，更省时，更优惠</span>
    </div>

    <div class="login-right-div">
      <div><img src="../../static/images/logo.png" class="login-logo"/></div>
      <div><span class="login-font">欢迎登录</span></div>
      <el-form  :inline="true"  @submit.native.prevent>
         <div>
            <img src="../../static/images/16-手机.png" class="login-phone-img" />
            <el-input  prefix-icon="el-authentica-pass"  autocomplete="off"  v-model="phoneNumber"  @blur="checkPhone()" maxlength="11" onkeyup="value=value.replace(/[^\d]/g,'')"  class="login-input-code" type="text"  placeholder="请输入手机号码"/>
              <span class="login-phoneNum-error" style="" v-show="phoneEerrTip">请输入正确的手机号码</span>
         </div>
          <div >
            <img src="../../static/images/认证通过.png" class="login-authentica-img" />
            <el-input  prefix-icon="el-authentica-pass"   v-model="verifyCode" @change="checkCode"  @blur="checkCode" maxlength="6" onkeyup="value=value.replace(/[^\d]/g,'')"  class="login-input-code" type="text"  placeholder="输入短信验证码">
            </el-input>
            <span class="login-line" v-show="show"></span>
            <span class="login-init-line" v-show="!show"></span>
            <span class="login-send-code" @click="sendCode()" v-show="show">发送验证码</span>
            <span v-show="!show" class="login-get-code" >{{count}}s后重新获取</span>
            <span class="error error-show" style="display: block;margin-left: 50px;position: absolute;color: #F54743;" v-show="errTip">{{errorMsg}}</span>
            <span class="error error-show" style="display: block;margin-left: 50px;position: absolute;color: #F54743;" v-show="errTip2">验证码不能为空</span>
          </div>
          <el-button type="primary" class="login-button"    @click="login()">登&emsp;录</el-button>
           </el-form>
      </div>
    </div>
    <div style="position: fixed;left: 0px;bottom: 0px;width: 100%;z-index:1;text-align: center; padding: 20px 0;    color: #999999;font-size: 14px;">
      Copyright ©2021 深圳市东宝信息技术有限公司 All Rights Reserved
    </div>
  </div>
</template>
<script>
import "../assets/icon/iconfont.css"
import "../assets/css/base.css"
import mallFooter from '../components/footer.vue'
 import axios from 'axios'
 const TIME_COUNT = 30; //更改倒计时时间
  export default{
      data(){
          return{
            errTip: false,
            errTip1: false,
            errTip2: false,
            phoneEerrTip:false,
            userToken:"",
            userName: '',
            errorMsg:"",
            userPwd: '',
            phoneNumber:"", //手机号
            verifyCode:"", //验证码
            btnTitle:"获取验证码",
            disabled:false,  //是否可点击
            errors:{}, //验证提示信息
            show: true, // 初始启用按钮
            count: '', // 初始化次数
            timer: null,
            screenHeight:document.body.clientHeight<640?true:false,
            clientWidth:document.body.clientWidth<1000?true:false
          }
      },
      created() {
        document.onkeyup= e =>{
          if (e.keyCode === 13) {
               this.login();
             }
          }
      },
      mounted(){
        this.$nextTick(()=>{
         window.onresize = () => {
          return (() => {
            this.screenHeight = document.body.clientHeight<640?true:false
            this.clientWidth = document.body.clientWidth<1000?true:false
          })()
        }
       })
      },
      destroyed(){
      },
      methods: {
        changeInput(e){
          this.$forceUpdate();
        },

        //登录
        login() {
          let _this = this;
          if(!this.checkPhone() || !this.checkCode()){
            return false;
          }
          var params = {
              "phone":this.phoneNumber,
              "smsCode":this.verifyCode
          }
          axios.post('/mallApi/mall/index/login',
              params//将参数传递给后台
          ).then((res) => {
              res = res.data;
              if(res.success) {
                // 将用户token保存
                localStorage.setItem('Authorization', res.result.token);
                localStorage.setItem('userName', res.result.companyInfo.shortName);
                localStorage.setItem('logoUrl', res.result.companyInfo.logoUrl);
                localStorage.setItem('phone', res.result.phone);
                localStorage.setItem('contractInfoId', res.result.contractInfo.id);
                _this.$router.push(this.$route.query.path || '/goodsList');
              } else {
                 _this.$message({
                      showClose: true,
                      message: res.message,
                      type: 'error'
                    });
              }
          }).catch((err) => {
              console.log(err);
          });

        },

      //// 验证手机号
        checkPhone() {
            var reg = /^1[0-9]{10}$/
            if (!reg.test(this.phoneNumber)) {
                this.phoneEerrTip = true;
                return false
            }else{
              this.phoneEerrTip = false;
              return true
            }
        },
      //校验验证码
        checkCode() {
            var codeRq = /^[0-9]{6}$/
            if(!codeRq.test(this.verifyCode)){
              this.errTip = true;
              this.errorMsg ="验证码不正确";
              return false;
            }else{
               this.errTip = false;
               this.errTip2 = false;
               return true;
            }
        },
      //获取验证码
        sendCode(){
          if (this.checkPhone()) {
            this.validateBtn();//获取验证码倒计时
              //调用短信平台接口获取验证码
              axios.post('/mallApi/mall/index/sms',{
                  "phone":this.phoneNumber
              }).then(res => {
                  res = res.data;
                  if(res.success){
                    this.$message({
                      message: res.message,
                      type: 'success'
                    });
                  }else{
                    this.$message.error(res.message);
                  }
              })
          }
        },
        //获取验证码倒计时
        validateBtn(){
          if (!this.timer) {
              this.count = TIME_COUNT;
              this.show = false;
              this.timer = setInterval(() => {
                if (this.count > 0 && this.count <= TIME_COUNT) {
                  this.count--;
                } else {
                  this.show = true;
                  clearInterval(this.timer); // 清除定时器
                  this.timer = null;
                }
              }, 1000)
          }
        },
        enterFunction(){
          //debugger
         // if(e.keyCode == 13){
            this.login();
         // }
        }
    },
    components: {
      mallFooter
    }
  }
</script>
<style >

.login-input-code input.el-input__inner{
      font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333;
}
.el-icon-search:hover{
  color: #287EFF
}

     .login-right-div ::-webkit-input-placeholder { /* WebKit, Blink, Edge */
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #999999;
      line-height: 20px; }

      .login-right-div:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #999999;
      line-height: 20px;}

      .login-right-div::-moz-placeholder { /* Mozilla Firefox 19+ */
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #999999;
      line-height: 20px; }

      .login-right-div:-ms-input-placeholder { /* Internet Explorer 10-11 */
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #999999;
      line-height: 20px; }
      .el-input--prefix .el-input__inner {
          padding-left: 40px;
          height: 50px !important;
      }
      .el-input__prefix, .el-input__suffix {
          position: absolute;
          top: 2px !important;
          -webkit-transition: all .3s;
          height: 100%;
          color: #C0C4CC;
          text-align: center;
          margin-left: 10px!important;
      }
      /* .el-input__inner {
            line-height: 0px!important;
            height: 30px!important;
      } */
      .footer__secondary .footer__inner {
            height: 40px !important;
      }
      .footer{
        background-color: transparent !important
      }
      .footer {
          margin-top: 20px !important;
          margin-bottom: 10px !important;
      }
        /* html {
      height: 100%;
      width: 100%;
      overflow: hidden;
  }  */
      .login-phone-img{
        margin-left: 65px;
        position: absolute;
        margin-top: 47px;
        z-index: 999999;
        width: 15px;
        height: 15px;
      }
      .login-div{
          width: 100%;
          background: url('../../static/images/backg.png') no-repeat center #6e6e6e;
          background-size: 100% 100%;
          background-attachment: fixed;
          position: relative;
          height: 100vh;
          overflow: hidden;
      }
      .login-div.is-height{
        height: auto;
      }
       .login-div.is-width{
        width: 1000px;
      }
      .login-div .login-centen-div{
            top: 50%;
            left: 50%;
            width: 920px;
            position: relative;
            height: 560px;
            transform: translate( -460px,-280px);
            overflow: hidden;
            z-index: 9;
            box-shadow: 0px 30px 43px 8px rgba(0, 0, 0, 0.1);
            border-radius: 8px;
      }
      .login-div.is-height .login-centen-div{
            top: 0%;
            left: 0%;
            transform: translate( 0px,0px);
            width: 920px;
            position: relative;
            height: 560px;
            margin: 40px auto;
            overflow: hidden;
            z-index: 9;
            box-shadow: 0px 30px 43px 8px rgba(0, 0, 0, 0.1);
            border-radius: 8px;
      }
      .login-img{
          background-image: url('../../static/images/login.png');
          width: 460px;
          height: 560px;
          float: left;
      }
      .login-img-fontBig{
          margin-left: 50px;
          position: absolute;
          margin-top: 70px;
          width: 240px;
          height: 38px;
          font-size: 40px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #FFFFFF;
          line-height: 20px;
      }
      .login-img-fontMedll{
          margin-left: 50px;
          position: absolute;
          margin-top: 118px;
          width: 200px;
          height: 19px;
          font-size: 20px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #FFFFFF;
          line-height: 36px;
      }
     .login-img-fontSmall{
          margin-left: 50px;
          position: absolute;
          margin-top: 150px;
          width: 182px;
          height: 14px;
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #FFFFFF;
          line-height: 36px;
    }
    .login-right-div{
          width: 460px;
          height: 560px;
          background: #fff;
          float: left;
    }
    .login-logo{
      margin-left: 113px;
      margin-top: 80px;
      width: 235px;
      height: 41px;
    }
    .login-font{
        height: 28px;
        font-size: 30px;
        font-family: 'PingFang SC';
        font-weight: 500;
        color: rgb(51, 51, 51);
        line-height: 20px;
        float: left;
        margin-left: 37%;
        margin-right: 36%;
        margin-top: 20px;
        width: 42%;
    }
    .login-phoneNum{
        width: 79%;
        height: 50px;
        background: rgb(255, 255, 255);
        border: 0px solid rgb(221, 221, 221);
        border-radius: 4px;
        margin-top: 70px;
        margin-left: 50px;
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #333;
    }
    .login-phoneNum-error{
        display: block;margin-left: 50px;position: absolute;color: #F54743;
    }
    .login-input-code{
      width: 79%;
        height: 50px;
        background: rgb(255, 255, 255);
        border: 0px solid rgb(221, 221, 221);
        border-radius: 4px;
        margin-top: 30px;
        margin-left: 50px;
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #333;
    }
    .login-authentica-img{
        position: absolute;
        margin-left: 65px;
        margin-top: 47px;
        z-index: 999999;
        width: 15px;
        height: 15px;
    }
    .login-init-line{
         margin-left: -117px;
        position: absolute;
        margin-top: 45px;
        width: 1px;
        height: 20px;
        background: #DDDDDD;
        border-radius: 1px 1px 1px 0px;
      }
      .login-line{
         margin-left: -102px;
        position: absolute;
        margin-top: 45px;
        width: 1px;
        height: 20px;
        background: #DDDDDD;
        border-radius: 1px 1px 1px 0px;
      }
      .login-send-code{
           margin-left: -86px;
           width: 100px;
          margin-top: 45px;
          display: inline-block;
          vertical-align: top;
          position: absolute;
          height: 13px;
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #287EFF;
          cursor:pointer ;
      }
       .login-get-code{
           margin-left: -105px;
           width: 100px;
          margin-top: 45px;
          display: inline-block;
          vertical-align: top;
          position: absolute;
          height: 13px;
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #666;
      }
      .login-button{
          margin-left: 50px;
          width: 79%;
          height: 50px;
          background: #287eff;
          border-radius: 4px;
          margin-top: 40px;
          font-size: 18px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #fff;
          line-height: 20px;
      }
     .login-button:hover{
        background: #126BF0;
     }
     .login-button:active{
        background: #126BF0;
     }
</style>



// WEBPACK FOOTER //
// login.vue?666f381f